import {
  NOTIFICACIONES_ADD,
} from '../../actions/constants/sistemaNotificaciones/notificaciones.constants';

const initialState = {
  title: undefined,
  message: undefined,
  timestamp: undefined,
};

export default function notificacionesReducer(state = initialState, { type, payload }) {
  switch (type) {
    case NOTIFICACIONES_ADD: {
      const { title, message } = payload;
      const currDate = new Date();
      const timestamp = currDate.getTime();
      return {
        title, message, timestamp,
      };
    }
    default:
      return state;
  }
}
